/* storybook-check-ignore */
import { Box, Text } from '@opendoor/bricks-next';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';

import { PropertyDetailsFragment } from '__generated__/athena';

import { PricingTraditional } from './Pricing';

interface PropertySummaryProps {
  property: PropertyDetailsFragment;
}

export const PropertySummary = ({ property }: PropertySummaryProps) => {
  return (
    <Box tag="hgroup">
      <Text tag="h1" typography="$subheaderLarge" pb={24}>
        <Text
          $largerThanSM={{
            typography: '$subheaderLarge',
          }}
          tag="span"
          typography="$subheaderSmall"
          fontWeight="$medium"
        >
          {property.street},
        </Text>
        <br />
        <Text
          $largerThanSM={{
            typography: '$subheaderLarge',
          }}
          tag="span"
          typography="$subheaderSmall"
          fontWeight="$medium"
          color="$contentTertiary"
        >
          {property.city}, {property.state} {property.zip}
        </Text>
      </Text>
      <Box tag="section">
        <PricingTraditional listPrice={property?.listPrice} />
        <Box flexDirection="row">
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary">
            {property.bedrooms} bds
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary" mx={8}>
            ·
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary">
            {property.bathrooms} ba
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary" mx={8}>
            ·
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary">
            {property.sqFtTotalLiving} sqft
          </Text>
          {property?.estimatedMonthlyPayment && (
            <>
              <Text tag="span" typography="$bodyMedium" color="$contentTertiary" mx={8}>
                ·
              </Text>
              <Text tag="p" typography="$bodyMedium" color="$contentTertiary">
                {`${formatCurrency(property?.estimatedMonthlyPayment)}/month est.`}
              </Text>
            </>
          )}
        </Box>
        {!!property?.schoolDistricts?.length && (
          <Box flexDirection="row">
            <Text tag="span" typography="$bodyMedium" color="$contentTertiary" pt="$2x">
              {property.schoolDistricts.join(' & ')}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};
